import { createContext, useState, useMemo } from "react";

export const RegularIncomeContext = createContext();

export const RegularIncomeProvider = ({ children }) => {
  const [isRegularIncomeSection, setIsRegularIncomeSection] = useState(false);
  const [flexiValueRegularIncome, setFlexiValueRegularIncome] = useState(0);
  const [miValueRegularIncome, setMiValueRegularIncome] = useState(0);
  const [faiValueRegularIncome, setFaiValueRegularIncome] = useState(0);

  const resetRegularIncomeValues = () => {
    setIsRegularIncomeSection(false);
    setFlexiValueRegularIncome(0);
    setMiValueRegularIncome(0);
    setFaiValueRegularIncome(0);
  };

  const value = useMemo(
    () => ({
      isRegularIncomeSection,
      setIsRegularIncomeSection,
      flexiValueRegularIncome,
      setFlexiValueRegularIncome,
      miValueRegularIncome,
      setMiValueRegularIncome,
      faiValueRegularIncome,
      setFaiValueRegularIncome,
      resetRegularIncomeValues,
    }),
    [
      isRegularIncomeSection,
      flexiValueRegularIncome,
      miValueRegularIncome,
      faiValueRegularIncome,
    ],
  );

  return (
    <RegularIncomeContext.Provider value={value}>
      {children}
    </RegularIncomeContext.Provider>
  );
};
